import React from 'react';
import { Container, Grid, Typography, Card, CardContent } from '@mui/material';
import { motion } from 'framer-motion';
import CloudQueueIcon from '@mui/icons-material/CloudQueue';
import StorageIcon from '@mui/icons-material/Storage';
import SecurityIcon from '@mui/icons-material/Security';
import CodeIcon from '@mui/icons-material/Code';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import BackupIcon from '@mui/icons-material/Backup';
import './CloudServices.css';

const services = [
  {
    icon: <CloudQueueIcon sx={{ fontSize: 40 }} />,
    title: 'Cloud Migration',
    description: 'Seamless migration of your existing infrastructure and applications to the cloud with minimal disruption.'
  },
  {
    icon: <StorageIcon sx={{ fontSize: 40 }} />,
    title: 'Cloud Infrastructure',
    description: 'Design and implementation of scalable, reliable cloud infrastructure using AWS, Azure, or Google Cloud.'
  },
  {
    icon: <SecurityIcon sx={{ fontSize: 40 }} />,
    title: 'Cloud Security',
    description: 'Comprehensive security solutions to protect your cloud infrastructure and data from threats.'
  },
  {
    icon: <CodeIcon sx={{ fontSize: 40 }} />,
    title: 'Cloud-Native Development',
    description: 'Development of cloud-native applications optimized for scalability and performance.'
  },
  {
    icon: <AnalyticsIcon sx={{ fontSize: 40 }} />,
    title: 'Cloud Analytics',
    description: 'Implementation of cloud-based analytics solutions for better business insights and decision-making.'
  },
  {
    icon: <BackupIcon sx={{ fontSize: 40 }} />,
    title: 'Managed Cloud Services',
    description: 'Ongoing management and optimization of your cloud infrastructure for maximum efficiency.'
  }
];

const CloudServices = () => {
  return (
    <section className="cloud-services">
      <Container maxWidth="lg">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <Typography variant="h2" className="cs-section-title" gutterBottom>
            Our Cloud Solutions Services
          </Typography>
          <Typography variant="subtitle1" className="cs-section-subtitle" gutterBottom>
            Comprehensive cloud services to power your digital transformation
          </Typography>
        </motion.div>

        <Grid container spacing={4} className="services-grid">
          {services.map((service, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
              >
                <Card className="cs-service-card">
                  <CardContent>
                    <div className="cs-service-icon">
                      {service.icon}
                    </div>
                    <Typography variant="h6" className="cs-service-title">
                      {service.title}
                    </Typography>
                    <Typography variant="body2" className="cs-service-description">
                      {service.description}
                    </Typography>
                  </CardContent>
                </Card>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </Container>
    </section>
  );
};

export default CloudServices; 